import { useReduxState } from 'hooks';
import api from 'api';
import { ConfirmButton, ConfirmDeleteButton } from 'components/common';

interface Props {
  completionId: number;
  updateUser: () => Promise<void>;
  userId: number;
}

const ProfileCoursePreviousCompletionsRemoveCompletion = ({
  completionId,
  userId,
  updateUser
}: Props) => {
  const {
    messages,
    serverConfig: { requireReasonWhenDeletingData }
  } = useReduxState();

  const handleConfirm = async (values?: { deletionReason?: string }) => {
    let url = `/admin/users/${userId}/course-completions/${completionId}`;

    if (values?.deletionReason) {
      url += `?deletionReason=${encodeURIComponent(values.deletionReason)}`;
    }

    await api.delete(url);
    await updateUser();
    return true;
  };

  return requireReasonWhenDeletingData ? (
    <ConfirmDeleteButton
      buttonCategory="lighter"
      buttonIsDropdown={true}
      buttonText={messages.completionManuallyCompletionDeleteButton}
      confirmText={messages.completionManuallyCompletionDeleteWarning}
      confirmTitle={messages.completionManuallyCompletionDeleteButton}
      id="deletionReasonCourseCompletion"
      onConfirm={handleConfirm}
      stopPropagation={true}
      successMessage={messages.completionManuallyCompletionDeleteSuccess}
    />
  ) : (
    <ConfirmButton
      actionText={messages.commonRemove}
      buttonCategory="lighter"
      buttonIcon="trash-alt"
      buttonIsDropdown={true}
      buttonSize="medium"
      buttonText={messages.completionManuallyCompletionDeleteButton}
      category="danger"
      confirmText={messages.completionManuallyCompletionDeleteWarning}
      confirmTitle={messages.completionManuallyCompletionDeleteButton}
      onConfirm={handleConfirm}
      successMessage={messages.completionManuallyCompletionDeleteSuccess}
      stopPropagation={true}
    />
  );
};

export default ProfileCoursePreviousCompletionsRemoveCompletion;
